export type OpenPromise<T> = Promise<T> & {
  resolve: (value: T) => void;
  reject: (err: any) => void;
  resolvedValue: T | null;
};

export function createOpenPromise<T>() {
  let resolve: (value: T) => void;
  let reject: (err: any) => void;
  const promise = new Promise((res, rej) => {
    resolve = res;
    reject = rej;
  }) as OpenPromise<T>;
  promise.resolvedValue = null;

  let isResolvedOrRejected = false;

  promise.resolve = (value: T) => {
    if (!isResolvedOrRejected) {
      resolve!(value);
      promise.resolvedValue = value;
      isResolvedOrRejected = true;
    }
  };
  promise.reject = (err: any) => {
    if (!isResolvedOrRejected) {
      reject!(err);
      isResolvedOrRejected = true;
    }
  };

  return promise;
}
